<template>
    <div class="flex flex-col">
        <select
            v-model="month"
            class="border border-gray-300 p-2 text-[16px] focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] focus:outline-none focus:outline-offset-0"
            :class="monthInputClass"
            :disabled="disabled"
        >
            <option
                :key="0"
                :value="0"
            >
                {{ $t('dropdownDateInput.month') }}
            </option>
            <option
                v-for="month in monthsOptions"
                :key="month.value"
                :value="month.value"
            >
                {{ month.name }}
            </option>
        </select>
        <small
            v-if="showMonthError"
            id="month-help"
            class="text-red-600 pl-2"
            >{{ $t('dropdownDateInput.monthRequired') }}</small
        >
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
    selectedMonth: number
    disabled: boolean
    invalid: boolean
    showErrors: boolean
}>()

const emit = defineEmits<{
    (e: 'update:selected-month', payload: number)
}>()

const { t } = useI18n()

// Vue does something to get the value from the options, I think,
// so I'm using the writable computed here to take advantage of that
// Using the raw event makes everything a string
const month = computed({
    get() {
        return props.selectedMonth
    },
    set(newValue) {
        emit('update:selected-month', newValue)
    }
})

const monthsOptions = [
    { name: t('dropdownDateInput.january'), value: 1 },
    { name: t('dropdownDateInput.february'), value: 2 },
    { name: t('dropdownDateInput.march'), value: 3 },
    { name: t('dropdownDateInput.april'), value: 4 },
    { name: t('dropdownDateInput.may'), value: 5 },
    { name: t('dropdownDateInput.june'), value: 6 },
    { name: t('dropdownDateInput.july'), value: 7 },
    { name: t('dropdownDateInput.august'), value: 8 },
    { name: t('dropdownDateInput.september'), value: 9 },
    { name: t('dropdownDateInput.october'), value: 10 },
    { name: t('dropdownDateInput.november'), value: 11 },
    { name: t('dropdownDateInput.december'), value: 12 }
]

const showMonthError = computed(() => {
    return props.selectedMonth === 0 && props.showErrors
})

const monthInputClass = computed(() => {
    if (props.disabled === true) {
        return 'text-gray-500'
    } else if (showMonthError.value || props.invalid) {
        return 'border-2 border-red-500'
    } else {
        return ''
    }
})
</script>
